const esJSON = {
  'Accent Sidebar': 'Barra lateral de acento',
  'Accent Header': 'Encabezado de acento'
};

export default esJSON;
